"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSubmit = void 0;
const helpers_1 = require("../helpers");
const handlers_1 = require("../handlers");
const handleSubmit = (callback, context) => (e) => {
    let canSubmit = true;
    let focusElement = true;
    const data = {};
    Object.entries(context.fields).forEach(([name, field]) => {
        if (field.ref.current) {
            const { fields, value, disabled } = (0, helpers_1.getPropsFromRef)(field.ref);
            if (disabled) {
                data[name] = '';
                return;
            }
            const element = fields[0];
            const isValid = (0, handlers_1.handleMethods)({ value, name, context, options: field.options });
            if (!isValid) {
                canSubmit = false;
                if (focusElement) {
                    element.focus();
                    focusElement = false;
                }
            }
            data[name] = value;
            context.actions?.setFieldValue(name, value);
        }
    });
    if (!canSubmit) {
        e && e.preventDefault && e.preventDefault();
        return;
    }
    callback(data, e);
};
exports.handleSubmit = handleSubmit;
